import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewChecked, AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Sgke031aResponseNrcptInfo } from 'sg-api';

@Component({
  selector: 'app-sgke030d-search-result',
  templateUrl: './sgke030d-search-result.component.html',
  styleUrls: ['./sgke030d-search-result.component.scss'],
})
export class Sgke030dSearchResultComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {

  /** 登録ボタンイベント */
  @Output() registEmit = new EventEmitter();
  /** 通常メッセージエミッター */
  @Output() normalMessageEmit = new EventEmitter();
  /** エラーメッセージエミッター */
  @Output() errorMessageEmit = new EventEmitter();
  /** SGKE020D再描画（再検索）エミッター */
  @Output() searchEmit = new EventEmitter();

  /** 検索結果リスト */
  @Input() searchResultList: Array<Sgke031aResponseNrcptInfo>;

  /** データソース */
  dataSource: MatTableDataSource<Sgke031aResponseNrcptInfo>;
  /** 選択した行の情報 */
  selection: SelectionModel<any> = new SelectionModel<Sgke031aResponseNrcptInfo>(false, []);

  /** ソート */
  @ViewChild('sort1', { static: true }) sort!: MatSort;
  /** ページネイター */
  @ViewChild('paginator1', { static: true }) paginator!: MatPaginator;

  /**  テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'select',
    'payDlineYearmonthdate',
    'claimYmd',
    'chargeDiv',
    'claimMethodCodeAname',
    'claimSts',
    'transferdateSalesreportdate',
    'claimAmt',
    'nrcptMny',
  ];

  /**
   * コンストラクタ
   * @memberof Sgke030dSearchResultComponent
   */
  constructor(
  ) { }

  /**
   * 初期処理
   * @memberof Sgke030dSearchResultComponent
   */
  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<Sgke031aResponseNrcptInfo>(this.searchResultList);
  }

  /**
 * 画面描画後初回処理
 * @memberof Sgke030dSearchResultComponent
 */
  ngAfterViewInit() {
    // 表データとソートを連携
    if (this.dataSource) {
      this.dataSource.sort ??= this.sort;
    }
  }

  /**
   * 画面描画後処理
   * @memberof Sgke030dSearchResultComponent
   */
  ngAfterViewChecked() {

    // 表データと、ソート/ページングを連携
    if (this.dataSource) {
      this.dataSource.paginator ??= this.paginator;
    }
  }

  /**
   * 終了処理
   * @memberof Sgke030dSearchResultComponent
   */
  ngOnDestroy() {
  }

  /**
   * 登録ボタン押下時
   *
   * @memberof Sgke030dSearchResultComponent
   */
  onRegist(): void {
    this.registEmit.emit(this.selection.selected);
  }

}
